import React from 'react'
import dayjs from 'dayjs'


function TreatmentDetailsCard({ treatmentInfo }) {

  const STYLES_DIV = {
     minWidth: '500px'
  }

    return (
    <div className='text-secondary bg-white rounded shadow flex  mb-4 lg:mb-0 flex-col p-10 flex-grow h-80' style={STYLES_DIV}>
        <div className='flex justify-between'>
            <h1 className="mb-5 text-2xl text-secondary">Treatment details</h1>
        </div>
        <div className='grid grid-cols-2 gap-y-2 gap-x-8'>
            <label >Treatment type:</label>
            <span className='font-semibold'>{treatmentInfo.treatment_type}</span>
            <label>Center of Excellence:</label>
            <span className='font-semibold'>{treatmentInfo.center_of_excellence.name}</span>
            <label>Created:</label>
            <span className='font-semibold'> {dayjs(treatmentInfo.created_at).format('DD/MM/YYYY')}</span>
        </div>
    </div>
  )
}

export default TreatmentDetailsCard

